export class CertificateIdsRequest {
  filter: string;
}

export class PersonalCertificateIds {
  personalCertificateIds: number[];
}

export class PersonalCertificateId {
  personalCertificateId: number;
}

export class PreloadedCertificateIds {
  preloadedCertificateIds: number[];
}

export class CertificateEditRequest {
  password: string;
  pin: string;
}

export class CertificateDeleteRequest {
  personalCertificateIds: number[];
}

export class CertificateDeleteReponse { }

export class RemovePinReponse { }

export class CertificateResetPinRequest {
  personalCertificateId: number;
  code: string;
  newPin: string;
}

export class CertificateResetPinReponse { }

export class CertificateChangePinRequest {
  personalCertificateId: number;
  currentPIN: string;
  newPIN: string;
}

export class RemovePinRequest {
  personalCertificateId: number;
  currentPIN: string;
}

export class CertificateChangePinResponse { }

export class CertificateFpDownloadRequest {
  certificateRequestId: number;
  passwordToEncrpyt: string;
  downloadingCode: string;
}

export class CertificateFpDownloadReponse { }

export class BaseCertificate {
  id: number;
  alias: string;
}

export class PersonalCertificate extends BaseCertificate {
  expiryTime: Date;
  type: number;
  resetPIN: boolean;
  active: boolean;
  requestId: number;
  hasPIN: boolean;
  capabilities: PersonalCertificateCapabilities[];
}

export class PreloadedCertificate extends BaseCertificate {
  uploadedTime: Date;
}

export class PreloadedCertificateActivateRequest {
  preloadedCertificateId: number;
  password: string;
  pin: string;
}

export enum CertificateType {
  PERSONAL = 'PERSONAL',
  CORPORATIVE = 'CORPORATIVE'
}

export enum PersonalCertificateCapabilities {
  DELETE = 'DELETE',
  RESET_PIN = 'RESET_PIN',
  CHANGE_PIN = 'CHANGE_PIN',
  DOWNLOAD = 'DOWNLOAD',
  REMOVE_PIN = 'REMOVE_PIN'
}

export enum PersonalCertificateOrderBy {
  ALIAS = 'ALIAS',
  EXPIRY_TIME = 'EXPIRY_TIME',
  TYPE = 'TYPE',
  RESET_PIN = 'RESET_PIN',
  ACTIVE = 'ACTIVE',
  HAS_PIN = 'HAS_PIN'
}

export enum PreloadedCertificateOrderBy {
  ALIAS = 'ALIAS',
  UPLOADED_TIME = 'UPLOADED_TIME'
}
